import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import i18next from 'i18next'
// utils
import { noop } from '../../utils/general'
import styles from './confirmationDialog.module.scss'

const ConfirmationDialog = ({
  onSubmit,
  onCancel,
  primaryBtnText,
  secondaryBtnText,
  isPrimaryBtnDisabled,
  isSecondaryBtnDisabled,
  title,
  content,
  showDialog,
  hasNewDesign,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={showDialog}
      onClose={onCancel}
      onClick={(e) => e.stopPropagation()}
    >
      {hasNewDesign && (
        <div className={styles.closeButtonContainer}>
          <Button
            className={styles.closeButton}
            disableRipple
            onClick={onCancel}
            endIcon={<CloseIcon className={styles.endIcon} />}
          >
            {t('edit-members-modal-close-button')}
          </Button>
        </div>
      )}
      <DialogTitle className={styles.heading}>
        {title}
        {!hasNewDesign && (
          <IconButton
            aria-label="close"
            onClick={onCancel}
            className={styles.iconBtn}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent
        className={hasNewDesign ? styles.containerPadding : styles.container}
      >
        {content}
      </DialogContent>
      <DialogActions
        className={hasNewDesign ? styles.actionsLeft : styles.actions}
      >
        <Button
          onClick={onCancel}
          type="submit"
          className={styles.cancelBtn}
          variant="contained"
          disabled={isSecondaryBtnDisabled}
        >
          {secondaryBtnText}
        </Button>
        <Button
          onClick={onSubmit}
          type="submit"
          className={styles.continueBtn}
          variant="contained"
          disabled={isPrimaryBtnDisabled}
        >
          {primaryBtnText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConfirmationDialog.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  primaryBtnText: PropTypes.string,
  secondaryBtnText: PropTypes.string,
  isPrimaryBtnDisabled: PropTypes.bool,
  isSecondaryBtnDisabled: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
  showDialog: PropTypes.bool,
  hasNewDesign: PropTypes.bool,
}

ConfirmationDialog.defaultProps = {
  onSubmit: noop,
  onCancel: noop,
  primaryBtnText: i18next.t('confirmation-dialog-primary-btn-text'),
  secondaryBtnText: i18next.t('confirmation-dialog-secondary-btn-text'),
  isPrimaryBtnDisabled: false,
  isSecondaryBtnDisabled: false,
  title: i18next.t('confirmation-dialog-title-text'),
  content: i18next.t('confirmation-dialog-content-text'),
  showDialog: false,
  hasNewDesign: false,
}

export default ConfirmationDialog
